import { HttpClient } from '@/api/clients/httpClient';
import { getApiConfig } from '@/api/config/client/getApiConfig';
import { StandardHeaders } from '@/api/headers';
import { ApiLogger } from '@/api/logger/apiLogger';
import { osDetector } from '@/api/osDetector/client';
import { parseUserLocation } from '@/api/parsers/parseUserLocation';
import type { UserLocation, UserLocationResponse } from '@/api/types/userLocationTypes';

import { type HttpOptions } from './httpClient';

const apiConfig = getApiConfig();
const { apiKey, isLogEnabled, entitlementBaseUrl } = apiConfig;

interface LocationParams {
  latitude?: number;
  longitude?: number;
}

/**
 * @see https://teamfox.atlassian.net/wiki/spaces/API/pages/362774789/Location
 */
export class LocationClient {
  public constructor(private httpClient: HttpClient) {}

  public async getUserLocation(params?: LocationParams, options?: HttpOptions): Promise<UserLocation | undefined> {
    const { latitude, longitude } = params ?? {};

    let data: UserLocationResponse | undefined;

    try {
      const queryString = latitude && longitude ? `?latitude=${latitude}&longitude=${longitude}` : '';

      data = await this.httpClient.get<UserLocationResponse>(`/locator/v1/location${queryString}`, options);

      const userLocation = parseUserLocation(data);

      return userLocation;
    } catch {}

    // If the API returns no data or it fails for some reason, we return an empty UserLocation object
  }
}

const logger = new ApiLogger('LocationClient', isLogEnabled);
const headers = new StandardHeaders(apiKey);
const httpClient = new HttpClient({ apiConfig, baseUrl: entitlementBaseUrl, logger, headers, osDetector });

export const locationClient = new LocationClient(httpClient);
